<div class="menu-item-container"
  [attr.data-testid]="getTestId()"
  (click)="handleIconClick()"
  [ngClass]="isEditMode ? 'cursor-move': 'cursor-pointer'"
  [style.pointer-events]="disableClick ? 'none' : 'auto'"
  cdkDragHandle>
  <div class="menu-item-circle" [ngClass]="menuItem.SortOrder === -1 ? 'hidden-state' : 'visible-state'" style="position: relative;">
    <div class="menu-item-icon-container">
      @if (shouldShowAppIcon()) {
        <div class="app-icon-wrapper">
          @if (iconServiceStatus === ServiceStatus.loading) {
            <div class="icon-loading-spinner">
              <mat-spinner diameter="24"></mat-spinner>
            </div>
          }
            @if (iconServiceStatus !== ServiceStatus.error) {
            <img
              class="menu-item-icon"
              [src]="getIconUrl()"
              (error)="iconServiceStatus = ServiceStatus.error"
              (load)="iconServiceStatus = ServiceStatus.loaded"
              (loadstart)="iconServiceStatus = ServiceStatus.loading"
              [style.opacity]="iconServiceStatus === ServiceStatus.loading ? '0.5' : '1'">
            }
          @if (iconServiceStatus === ServiceStatus.error) {
            <div>
              <i class="icon-broken-image icon-text-blue" style="width: 24px; height: 24px;"></i>
            </div>
          }
        </div>
      }

      @if (menuItem.ItemType === MenuItemType.Profile && currentUserProfile) {
        <user-image
          #profileUserImage
          [userId]="currentUserProfile.Id"
          [profileEnabled]="false"
          [isCircle]="true"
          [size]="'100%'">
        </user-image>
      }
      @if (menuItem.ItemType === MenuItemType.Student) {
        <user-image
          #studentUserImage
          [userId]="menuItem.Id"
          [profileEnabled]="false"
          [isCircle]="true"
          [size]="'100%'">
        </user-image>
      }
    </div>

    @if (menuItem.Notifications > 0) {
      <div class="menu-item-badge">
        {{menuItem.Notifications > 9 ? '9+': menuItem.Notifications}}
      </div>
    }
    @if (isEditMode) {
      <div class="menu-item-buttons-outer" [ngClass]="menuItem.SortOrder === -1 ? 'hidden-state' : 'visible-state'"
        >
        @if (menuItem.CanBeHidden) {
          <button type="button" mat-mini-fab
            class="btn btn-icon"
            (click)="handleToggleVisibilityClick()"
            >

            @if (menuItem.SortOrder === -1) {
              <i class="icon-visibility-off icon-action-blue" style="width: 14px; height: 14px; margin: 2px;"></i>
            }
            @if (menuItem.SortOrder >= 0) {
              <i class="icon-visibility icon-white" style="width: 14px; height: 14px; margin: 2px;"></i>
            }
          </button>
        }
      </div>
    }
  </div>
  <div class="menu-item-title-outer"
    (click)="handleTitleClick()">
    <h5 class="menu-item-title" [ngClass]="menuItem.SortOrder === -1 && menuItem.ItemType === MenuItemType.App  ? 'hidden-state' : 'visible-state'">
      {{menuItem.Title}}
    </h5>
  </div>
</div>

<div class="menu-item-outer menu-item-dark-background"
  *cdkDragPlaceholder>
  <div class="menu-item-icon-outer">

  </div>
</div>
